function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.5,19.5 L9,11.5 L3.5,11.5 L2,13.5 L0.5,13.5 L1.5,10 L0.5,6.5 L2,6.5 L3.5,8.5 L9,8.5 L6.5,0.5 L8.5,0.5 L13.5,8.5 L19,8.5 C19.83,8.5 20.5,9.17 20.5,10 C20.5,10.83 19.83,11.5 19,11.5 L13.5,11.5 L8.5,19.5 L6.5,19.5 Z"
});

var SvgPlane = function SvgPlane(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlane, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane.a81de9fe.svg";
export { ForwardRef as ReactComponent };